export const changePasswordResourceType = 'change_password';
export const changePasswordResourcePath = '/change_password';
